import { HealthAndSafety } from "@mui/icons-material";
import { useSessionContext } from "../../contexts/SessionContext";
import { IFeatures } from "../../utils/interfaces";

import PatientInsurance from "./PatientInsurance";
import { currentFeatures } from "@/configs/Settings";

export function usePatientInsurance() {
  const { access } = useSessionContext();

  const configs: IFeatures = {
    active: access.type === "patient" && currentFeatures.defaultApp,
    path: "/insuranceplan",
    icon: HealthAndSafety,
    text: "Plano de saúde",

    sideMenu: true,
    sideMenuIndex: 3,

    avatarMenu: true,
    avatarIndex: 1,
    component: () => <PatientInsurance />,
  };

  return configs;
}
